<template>
  <div>
    <ConfirmationModal
      :title="$t('labels.warning')"
      :message="$t('description.deleteModalDescription')"
      :confirm="deleteItem"
      v-model="deleteItemConfirmationModal"
    />
    <v-card elevation="1">
      <v-card-title style="color: var(--darkBlue)">
        <v-row>
          <v-col class="text-lg-left text-center" lg="5" cols="12">
            <h3>{{ $t('navigationDrawerMenu.additionalCosts') }}</h3>
          </v-col>
        </v-row>
        <v-icon
          v-if="
            $store.state.Type === 'Supplier' ||
            $store.state.Type === 'Accountant'
          "
          @click="
            costDialog = true;
            editFlag = false;
          "
          small
          class="mr-6"
          style="font-size: 32px"
        >
          mdi-plus-box-outline
        </v-icon>
        <RefreshButton :refreshFunction="getItems"></RefreshButton>
      </v-card-title>

      <v-divider />
      <v-data-table
        :headers="headers"
        :items="list"
        :options="{
          itemsPerPage,
        }"
        style="padding: 0 16px"
        hide-default-footer
        :loading="$store.state.loadingStatus"
        :no-data-text="$t('messages.noData')"
        ><!-- eslint-disable -->
        <template v-slot:item.PhotoUrl="{ item }">
          <img
            :src="item.PhotoUrl"
            :alt="item.Title"
            style="width: 50px; height: 50px; object-fit: contain"
          />
        </template>
        <template v-slot:item.Status="{ item }">
          <v-chip
            class="ma-2"
            small
            :color="item.IsActive ? 'green' : 'red'"
            text-color="white"
          >
            {{ $t(`labels.tooltip${item.IsActive ? 'Active' : 'Passive'}`) }}
          </v-chip>
        </template>
        <template v-slot:item.CreatedOnUtc="{ item }">
          {{ convertToLocal(item.CreatedOnUtc) }}
        </template>
        <template v-slot:item.Country="{ item }">
          {{ item.Country + ' ' + item.City }}
        </template>
        <template v-slot:item.LogisticType="{ item }">
          {{ item.LogisticType === 1 ? 'FedEx' : 'UPS' }}
        </template>
        <template v-slot:item.AdditionalCostType="{ item }">
          {{
            types[item.AdditionalCostType]
              ? types[item.AdditionalCostType].name
              : ''
          }}
        </template>
        <template v-slot:item.DisplayName="{ item }">
          {{ item.DisplayName || '-' }}
        </template>
        <template v-slot:item.CostParameter="{ item }">
          {{
            displayCostParameters[item.CostParameter]
              ? displayCostParameters[item.CostParameter].name
              : ''
          }}
        </template>
        <template v-slot:item.MinValue="{ item }">
          {{ item.MinValue ? item.MinValue : '-' }}
        </template>
        <template v-slot:item.PortalCustomerType="{ item }">
          <v-chip
            v-if="item.PortalCustomerType == 0"
            class="ma-2"
            small
            color="#c5f4db"
            text-color="#2b3838"
          >
            {{ $t('labels.tooltipCorporate') }}
          </v-chip>

          <v-chip
            v-if="item.PortalCustomerType == 1"
            class="ma-2 text--center"
            small
            color="#e3e2e3"
            text-color="#2b3838"
          >
            {{ $t('labels.tooltipMarketPlace') }}
          </v-chip>
        </template>
        <template v-slot:item.StatusType="{ item }">
          <v-chip
            v-if="item.StatusType == 1"
            class="ma-2"
            small
            color="#c5f4db"
            text-color="#2b3838"
          >
            {{ $t('labels.tooltipActive') }}
          </v-chip>

          <v-chip
            v-if="item.StatusType == 2"
            class="ma-2 text--center"
            small
            color="#e3e2e3"
            text-color="#2b3838"
          >
            {{ $t('labels.tooltipPassive') }}
          </v-chip>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="d-flex">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="#29B7B7"
                  class="mr-1"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="updateCost(item)"
                >
                  mdi-pencil
                </v-icon>
              </template>
              <span>{{ $t('labels.tooltipEdit') }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  small
                  color="red"
                  style="font-size: 20px"
                  v-bind="attrs"
                  v-on="on"
                  @click="
                    deleteItemConfirmationModal = true;
                    selectedItem = item.Id;
                  "
                >
                  mdi-trash-can
                </v-icon>
              </template>
              <span>{{ $t('labels.deleteKey') }}</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>

      <v-dialog v-model="costDialog" @input="resetDialog" max-width="800">
        <v-card class="popup-card" elevation="1">
          <v-card-title
            class="popupHeadline d-flex justify-center"
            style="font-size: 16px"
          >
            {{ $t('labels.addAdditionalCost') }}
          </v-card-title>

          <v-divider></v-divider>
          <ValidationObserver v-slot="{ handleSubmit, errors }" ref="observer">
            <v-card-text class="mt-2">
              <form @submit.prevent="handleSubmit(submitCost)">
                <v-row style="padding-bottom: 15px">
                  <FormElement
                    v-for="(element, index) in formElement"
                    :key="
                      element.key.parent + '_' + element.key.child + '_' + index
                    "
                    v-model="$data[element.key.parent][element.key.child]"
                    :validationLabel="$t(element.validationLabel)"
                    :rules="element.rules"
                    :formLabel="$t(element.formLabel)"
                    :onChange="element.onChange"
                    :formType="element.formType"
                    :lg="element.lg"
                    :cols="element.cols"
                    :hidden="element.hidden"
                    :labelShown="element.labelShown"
                    :topLabel="element.topLabel"
                    :active="element.active"
                    :placeholder="$t(element.placeholder)"
                    :willBeEliminated="false"
                    :classes="element.classes"
                  />
                </v-row>

                <v-card-actions class="d-flex justify-center">
                  <v-btn
                    style="
                      color: #fff;
                      text-transform: unset !important;
                      background-color: #0077d5;
                      padding: 2vh 3vh;
                      border-radius: 30px !important;
                      font-weight: bolder;
                      font-size: medium;
                    "
                    elevation="0"
                    class="darken-1"
                    type="submit"
                    color="primary"
                  >
                    {{
                      !editFlag ? $t('buttons.add') : $t('buttons.update')
                    }}</v-btn
                  >
                  <v-btn
                    style="
                      color: #fff;
                      text-transform: unset !important;
                      background-color: var(--red);
                      padding: 2vh 2vh;
                      border-radius: 30px !important;
                      font-weight: bolder;
                      font-size: medium;
                    "
                    elevation="0"
                    class="darken-1"
                    @click="costDialog = false"
                    >{{ $t('buttons.cancel') }}</v-btn
                  >
                </v-card-actions>
              </form>
            </v-card-text>
          </ValidationObserver>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import RefreshButton from '../components/RefreshButton.vue';
import FormElement from '../components/FormElement.vue';
import ConfirmationModal from '../components/General/ConfirmationModal.vue';
import AdditionalCostsServices from '../services/AdditionalCostsServices';
import { logisticsTypes, getPortalUsers } from '../utils/constants';
import { isString } from 'lodash';

export default {
  data: () => ({
    costCategories: [],
    users: [],
    form: {
      PaymetTime: 0,
    },
    costDialog: false,
    headers: [],
    itemsPerPageOptions: [],
    itemsPerPage: 99999999999999999,
    page: 1,
    totalItems: 0,

    perPageValues: [
      {
        name: '5',
        value: 5,
      },
      {
        name: '10',
        value: 10,
      },
      {
        name: '15',
        value: 15,
      },
      {
        name: '30',
        value: 30,
      },
      {
        name: '50',
        value: 50,
      },
      {
        name: '100',
        value: 100,
      },
    ],

    deleteItemConfirmationModal: false,
    selectedItem: '',
    list: [],
    costParameters: [],
    displayCostParameters: [],
    editFlag: false,

    portalUsers: [],

    types: [],
  }),
  async mounted() {
    this.portalUsers = await getPortalUsers();

    this.types = [
      {
        name: this.$t('labels.circumference'),
        value: 0,
      },
      {
        name: this.$t('labels.ddp'),
        value: 1,
      },
      {
        name: this.$t('labels.additionalHandling'),
        value: 2,
      },
      {
        name: this.$t('labels.personalDelivery'),
        value: 3,
      },
      {
        name: this.$t('labels.oversize'),
        value: 4,
      },
      {
        name: this.$t('labels.insurance'),
        value: 5,
      },
      {
        name: this.$t('labels.signedDelivery'),
        value: 6,
      },
      {
        name: this.$t('labels.eph'),
        value: 7,
      },
      {
        name: this.$t('labels.additionalHandlingEnviromental'),
        value: 8,
      },
      {
        name: this.$t('labels.additionalHandlingWeight'),
        value: 9,
      },
      {
        name: this.$t('labels.heavyHandling'),
        value: 10,
      },
      {
        name: this.$t('labels.bigSize'),
        value: 11,
      },
      {
        name: this.$t('labels.peakSeason'),
        value: 12,
      },
      {
        name: 'DDPV2',
        value: 13,
      },
      {
        name: 'IPF',
        value: 14,
      },
      {
        name: this.$t('labels.twoEdgeLimit'),
        value: 15,
      },
      {
        name: this.$t('labels.avgWeightPerCap'),
        value: 16,
      },
      {
        name: this.$t('labels.totalMeasurement'),
        value: 17,
      },
      {
        name: this.$t('labels.overmax'),
        value: 18,
      },
    ];

    this.displayCostParameters = [
      {
        name: this.$t('labels.fixedPrice'),
        value: 0,
      },
      {
        name: this.$t('labels.perOrder'),
        value: 1,
      },
      {
        name: this.$t('labels.perPackage'),
        value: 2,
      },
      {
        name: this.$t('labels.perWeight'),
        value: 3,
      },
      {
        name: this.$t('labels.perProductPrice'),
        value: 4,
      },
      {
        name: this.$t('labels.basePricePercentage'),
        value: 5,
      },
      {
        name: this.$t('labels.avgWeightPerCap'),
        value: 6,
      },
      {
        name: this.$t('labels.totalMeasurement'),
        value: 7,
      },
    ];

    this.headers = [
      {
        text: this.$t('titles.integration.logisticsCompany'),
        value: 'LogisticType',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.additionalCostType'),
        value: 'AdditionalCostType',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.displayName'),
        value: 'DisplayName',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.costParameter'),
        value: 'CostParameter',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.cost'),
        value: 'Value',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.minValue'),
        value: 'MinValue',
        sortable: false,
        align: 'center',
      },
      {
        text: this.$t('labels.status'),
        value: 'Status',
        sortable: false,
        align: 'center',
      },
    ];
    if (
      this.$store.state.Type === 'Supplier' ||
      this.$store.state.Type === 'Accountant'
    ) {
      this.headers.push({
        text: this.$t('labels.actions'),
        value: 'actions',
        sortable: false,
      });
    }
    this.getItems();
    this.getCostCategories()
  },
  watch: {
    costDialog(newValue) {
      if (!newValue) {
        this.resetDialog();
      }
    },
  },
  components: {
    RefreshButton,
    FormElement,
    ConfirmationModal,
  },
  computed: {
    additionalCostTypes() {
      if (!this.form.LogisticType) return [];

      let specialTypes = [];
      if (this.form.LogisticType == 1) {
        specialTypes = this.types.filter((i) => i.value !== 2);
      } else {
        specialTypes = this.types.filter((i) => i.value !== 8 && i.value !== 9);
      }

      return specialTypes;
    },
    formElement() {
      return [
        {
          key: {
            parent: 'form',
            child: 'LogisticType',
          },
          rules: 'required',
          validationLabel: 'titles.subsupplier',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: logisticsTypes,
              value: 'Value',
              text: 'Name',
            },
          },
          onChange: () => (this.form.AdditionalCostType = null),
          lg: 6,
          placeholder: 'titles.subsupplier',
        },
        {
          key: {
            parent: 'form',
            child: 'DisplayName',
          },
          rules: '',
          validationLabel: 'labels.displayName',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          placeholder: 'labels.displayName',
        },
        {
          key: {
            parent: 'form',
            child: 'AdditionalCostType',
          },
          rules: 'required',
          validationLabel: 'labels.additionalCostType',
          topLabel: true,
          labelShown: false,
          onChange: (value) => {
            if (value === 4 || value === 2 || value === 0) {
              this.costParameters = [
                {
                  name: this.$t('labels.perPackage'),
                  value: 2,
                },
                {
                  name: this.$t('labels.perWeight'),
                  value: 3,
                },
              ];
            } else if (value === 7) {
              this.costParameters = [
                {
                  name: this.$t('labels.basePricePercentage'),
                  value: 5,
                },
              ];
            } else {
              this.costParameters = [
                {
                  name: this.$t('labels.fixedPrice'),
                  value: 0,
                },
                {
                  name: this.$t('labels.perOrder'),
                  value: 1,
                },
                {
                  name: this.$t('labels.perPackage'),
                  value: 2,
                },
                {
                  name: this.$t('labels.perWeight'),
                  value: 3,
                },
                {
                  name: this.$t('labels.perProductPrice'),
                  value: 4,
                },
              ];
            }
          },
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.additionalCostTypes,
              value: 'value',
              text: 'name',
            },
          },
          lg: 6,
          placeholder: 'labels.additionalCostType',
        },
        {
          key: {
            parent: 'form',
            child: 'SumWeight',
          },
          rules: 'required|double',
          validationLabel: 'labels.sumWeightEPH',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active: this.form.AdditionalCostType === 7,
          placeholder: 'labels.sumWeightEPH',
        },
        {
          key: {
            parent: 'form',
            child: 'SumVolume',
          },
          rules: 'required|double',
          validationLabel: 'labels.sumVolumeEPH',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active: this.form.AdditionalCostType === 7,
          placeholder: 'labels.sumVolumeEPH',
        },
        {
          key: {
            parent: 'form',
            child: 'WeightPerCap',
          },
          rules: 'required|numeric',
          validationLabel: 'labels.weightPerCap',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active:
            this.form.AdditionalCostType === 4 ||
            this.form.AdditionalCostType === 2 ||
            this.form.AdditionalCostType === 9,
          placeholder: 'labels.weightPerCap',
        },
        {
          key: {
            parent: 'form',
            child: 'AvgWeightPerCap',
          },
          rules: 'required|numeric',
          validationLabel: 'labels.avgWeightPerCap',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active: this.form.AdditionalCostType === 16,
          placeholder: 'labels.avgWeightPerCap',
        },
        {
          key: {
            parent: 'form',
            child: 'Circumference',
          },
          rules: 'required|numeric',
          validationLabel: 'labels.circumferenceLimit',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          active:
            this.form.AdditionalCostType === 0 ||
            this.form.AdditionalCostType === 4 ||
            this.form.AdditionalCostType === 8 ||
            this.form.AdditionalCostType === 11,
          lg: 6,
          placeholder: 'labels.circumferenceLimit',
        },
        {
          key: {
            parent: 'form',
            child: 'MaxSideLength',
          },
          rules: 'required|numeric',
          validationLabel: 'labels.maxSideLength',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active:
            this.form.AdditionalCostType === 2 ||
            this.form.AdditionalCostType === 8 ||
            this.form.AdditionalCostType === 10 ||
            this.form.AdditionalCostType === 11 ||
            this.form.AdditionalCostType === 15 ||
            this.form.AdditionalCostType === 18,
          placeholder: 'labels.maxSideLength',
        },
        {
          key: {
            parent: 'form',
            child: 'MiddleSideLength',
          },
          rules: 'required|numeric',
          validationLabel: 'labels.secondMaxSideLength',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active:
            this.form.AdditionalCostType === 2 ||
            this.form.AdditionalCostType === 8 ||
            this.form.AdditionalCostType === 15,
          placeholder: 'labels.secondMaxSideLength',
        },
        {
          key: {
            parent: 'form',
            child: 'TotalMeasurement',
          },
          rules: 'required|numeric',
          validationLabel: 'labels.totalMeasurement',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          active:
            this.form.AdditionalCostType === 17 ||
            this.form.AdditionalCostType === 18,
          placeholder: 'labels.totalMeasurement',
        },
        {
          key: {
            parent: 'form',
            child: 'CostParameter',
          },
          rules: 'required',
          validationLabel: 'labels.costParameter',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.costParameters,
              value: 'value',
              text: 'name',
            },
          },
          lg: 6,
          placeholder: 'labels.costParameter',
        },
        {
          key: {
            parent: 'form',
            child: 'Value',
          },
          rules: 'required',
          validationLabel: 'labels.cost',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          placeholder: 'labels.cost',
        },
        {
          key: {
            parent: 'form',
            child: 'MinValue',
          },
          rules: 'double',
          validationLabel: 'labels.minValue',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'text',
          },
          lg: 6,
          placeholder: 'labels.minValue',
        },
         
        {
          key: {
            parent: 'form',
            child: 'CategoryId',
          },
          validationLabel: 'labels.category',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'multipleSelect',
            items: {
              data: this.costCategories,
              value: 'Id',
              text: 'Name',
              disableAutoSelection: true,
              onAddNewItem: (categoryName) => this.quickAddCategory(categoryName),
            },
          },
          lg: 6,
          cols: 12,
          placeholder: 'labels.category',
        },

        {
          key: {
            parent: 'form',
            child: 'PortalIds',
          },
          formType: {
            name: 'checkTable',
            visible: true,
            unselectedItems: this.portalUsers,
            selectedItems: this.form.PortalIds || [],
          },
          labelShown: false,
        },

        {
          key: {
            parent: 'form',
            child: 'IsActive',
          },
          validationLabel: 'labels.tooltipActive',
          topLabel: true,
          labelShown: false,
          formType: {
            name: 'checkbox',
          },
          classes: 'mt-4',
          active: this.editFlag,
          lg: 6,
          placeholder: 'labels.tooltipActive',
        },
        // {
        //   key: {
        //     parent: 'form',
        //     child: 'PortalIds',
        //   },
        //   validationLabel: 'labels.portalUsers',
        //   topLabel: true,
        //   labelShown: false,
        //   formType: {
        //     name: 'multipleSelect',
        //     items: {
        //       data: this.portalUsers,
        //       value: 'Id',
        //       text: 'CompanyName',
        //     },
        //     multiple: true,
        //   },
        //   lg: 6,
        //   placeholder: 'labels.portalUsers',
        // },
      ];
    },
    pageLength() {
      //   return Math.ceil(this.totalItems / this.itemsPerPage);
    },
  },
  methods: {
    async getCostCategories(){
      this.$store.state.loadingStatus = true;
      await AdditionalCostsServices.getCostCategories()
      .then(response => {
        const data = response.data?.Result;
        if(Array.isArray(data) && data.length > 0){
          this.costCategories = data;
        }
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      })
    },
    async quickAddCategory(categoryName) {
      this.$store.state.loadingStatus = true;
      await AdditionalCostsServices.addNewCostCategory({ Name: categoryName })
      .then(response => {
        const data = response?.data?.Result;
        if(isString(data)){
          this.costCategories.unshift({ Id: data, Name: categoryName })
          this.form.CategoryId = data;
        }
        window.showSuccess(this.$t('messages.successfulAddGeneral'))
      })
      .catch(window.showError)
      .finally(() => {
        this.$store.state.loadingStatus = false;
      })
    },
    getItems() {
      this.$store.state.loadingStatus = true;
      AdditionalCostsServices.get()
        .then((response) => {
          this.list = response.data.Result;
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
        });
    },
    resetDialog() {
      this.$refs.observer.reset();
      this.form = {};
    },

    deleteItem() {
      if (this.selectedItem) {
        this.$store.state.loadingStatus = true;
        AdditionalCostsServices.delete(this.selectedItem)
          .then((response) => {
            window.showSuccess(
              this.$t('messages.successfulDelete', {
                value: this.$t('labels.user.singular'),
              })
            );
            this.getItems();
          })
          .catch(window.showError)
          .finally(() => {
            this.$store.state.loadingStatus = false;
          });
      }
    },
    submitCost() {
      this.$store.state.loadingStatus = true;
      this.form.SumWeight
        ? (this.form.SumWeight = parseFloat(this.form.SumWeight))
        : null;
      this.form.SumVolume
        ? (this.form.SumVolume = parseFloat(this.form.SumVolume))
        : null;
      this.form.TotalMeasurement
        ? (this.form.TotalMeasurement = parseFloat(this.form.TotalMeasurement))
        : null;
      this.form.AvgWeightPerCap
        ? (this.form.AvgWeightPerCap = parseFloat(this.form.AvgWeightPerCap))
        : null;
      this.form.WeightPerCap
        ? (this.form.WeightPerCap = parseFloat(this.form.WeightPerCap))
        : null;
      AdditionalCostsServices[this.editFlag ? 'update' : 'add'](this.form)
        .then((response) => {
          this.getItems();
        })
        .catch(window.showError)
        .finally(() => {
          this.$store.state.loadingStatus = false;
          this.costDialog = false;
          this.costParameters = [
            {
              name: this.$t('labels.fixedPrice'),
              value: 0,
            },
            {
              name: this.$t('labels.perOrder'),
              value: 1,
            },
            {
              name: this.$t('labels.perPackage'),
              value: 2,
            },
            {
              name: this.$t('labels.perWeight'),
              value: 3,
            },
            {
              name: this.$t('labels.perProductPrice'),
              value: 4,
            },
          ];
        });
    },
    updateCost(item) {
      this.form = Object.assign({}, item);
      this.form.PortalIds = item.PortalIds;

      if (
        this.form.AdditionalCostType === 4 ||
        this.form.AdditionalCostType === 2 ||
        this.form.AdditionalCostType === 0
      ) {
        this.costParameters = [
          {
            name: this.$t('labels.perPackage'),
            value: 2,
          },
          {
            name: this.$t('labels.perWeight'),
            value: 3,
          },
        ];
      } else if (this.form.AdditionalCostType === 7) {
        this.costParameters = [
          {
            name: this.$t('labels.basePricePercentage'),
            value: 5,
          },
        ];
      } else {
        this.costParameters = [
          {
            name: this.$t('labels.fixedPrice'),
            value: 0,
          },
          {
            name: this.$t('labels.perOrder'),
            value: 1,
          },
          {
            name: this.$t('labels.perPackage'),
            value: 2,
          },
          {
            name: this.$t('labels.perWeight'),
            value: 3,
          },
          {
            name: this.$t('labels.perProductPrice'),
            value: 4,
          },
        ];
      }

      this.costDialog = true;
      this.editFlag = true;
    },
  },
};
</script>
